const state = {
  date: {},
  nota: {},
  token: "",
  produtos: [],
  beneficio: {},
};

export default state;
